import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';

export const AdminTransactionsTab = ({ transactions, revenue, loadDashboardData }) => {
  const { t } = useTranslation();

  return (
    <div className="transactions-content" data-testid="admin-transactions-tab">
      <div className="section-header">
        <h3>{t('admin.transactions.title')}</h3>
        {revenue && (
          <div className="revenue-summary">
            <div className="revenue-grid">
              <div className="revenue-card"><span>{t('admin.transactions.grossVolume')}</span><strong>{revenue.total_volume || 0}€</strong></div>
              <div className="revenue-card pending"><span>{t('admin.transactions.pendingPayout')}</span><strong>{revenue.pending_amount || 0}€</strong></div>
              <div className="revenue-card refunded"><span>{t('admin.transactions.refunded')}</span><strong>{revenue.refunded_amount || 0}€</strong></div>
              <div className="revenue-card earnings"><span>{t('admin.transactions.platformProfit')}</span><strong>{revenue.total_revenue || 0}€</strong></div>
            </div>
          </div>
        )}
      </div>
      
      {transactions.length === 0 ? (
        <div className="empty-state">
          <p>{t('admin.transactions.noTransactions')}</p>
          <button onClick={loadDashboardData} className="btn-primary"><RefreshCw size={16} /> {t('admin.actions.reload')}</button>
        </div>
      ) : (
        <div className="admin-table">
          <table>
            <thead>
              <tr>
                <th>{t('admin.transactions.id')}</th>
                <th>{t('admin.transactions.user')}</th>
                <th>{t('admin.transactions.amount')}</th>
                <th>{t('admin.transactions.driverPayout')}</th>
                <th>{t('admin.transactions.platformFee')}</th>
                <th>{t('admin.transactions.status')}</th>
                <th>{t('admin.transactions.date')}</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map(tx => (
                <tr key={tx.transaction_id || tx.id}>
                  <td className="transaction-id">{(tx.transaction_id || tx.id || 'N/A').substring(0, 8)}...</td>
                  <td>{tx.user_name || tx.rider_id || t('common.unknown')}</td>
                  <td className={`amount ${tx.amount >= 0 ? 'positive' : 'negative'}`}>{tx.amount || 0}€</td>
                  <td>{tx.driver_payout || 0}€</td>
                  <td>{tx.platform_fee || 0}€</td>
                  <td>
                    <span className={`badge ${tx.status || 'unknown'}`}>
                      {tx.status === 'held' ? t('admin.transactions.statusHeld') : 
                       tx.status === 'released' ? t('admin.transactions.statusReleased') : 
                       tx.status === 'refunded' ? t('admin.transactions.statusRefunded') : 
                       tx.status || t('common.unknown')}
                    </span>
                  </td>
                  <td>{new Date(tx.createdAt || tx.timestamp || Date.now()).toLocaleDateString('de-DE')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
